import {fetchJSONByPost} from './index.js'

export const getListApi = (body) => fetchJSONByPost('/adms_api_v0/product/spu/mapping', body)
export const exportApi = (body) => fetchJSONByPost('/adms_api_v0/product/spu/mapping/excel', body, {responseType: 'blob'})